module.exports = {
	"classes": [
		"about-page",
		"header"
	],
	"title": "About",
	"metas": {
		"description": "Advanced identity management can be very hard. Very often, unnecessarily hard. At Auth0 we want to change that, by simplifying as much as possible."
	},
	"opengraph": {},
	"twittercard": {}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/metadata.json
// module id = 1103
// module chunks = 0